export default "__VITE_PUBLIC_ASSET__1d1fd1cc__"